import React from 'react';
import { useRegion } from '../contexts/RegionContext';
import { motion } from 'framer-motion';
import { HiGlobeAlt } from 'react-icons/hi';

interface LanguageToggleProps {
  className?: string;
  showLabel?: boolean;
}

export const LanguageToggle: React.FC<LanguageToggleProps> = ({
  className = '',
  showLabel = true,
}) => {
  const { language, toggleLanguage } = useRegion();

  const isFa = language === 'fa';

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={toggleLanguage}
      type="button"
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl border transition-all duration-200 select-none ${
        isFa
          ? 'bg-zinc-900/80 hover:bg-zinc-800 text-zinc-200 border-white/10 hover:border-primary/50'
          : 'bg-zinc-900/80 hover:bg-zinc-800 text-amber-400 border-amber-500/30 hover:border-amber-400'
      } ${className}`}
      aria-label={isFa ? 'Switch to English' : 'تغییر به زبان فارسی'}
      title={isFa ? 'تغییر زبان به انگلیسی (EN)' : 'Switch language to Persian (FA)'}
    >
      <HiGlobeAlt className={`w-4 h-4 ${isFa ? 'text-gray-400' : 'text-primary'}`} />
      <span className="text-xs font-black tracking-wide uppercase font-mono">
        {isFa ? 'EN' : 'فا'}
      </span>
      {showLabel && (
        <span className="text-[11px] text-gray-400 hidden sm:inline">
          {isFa ? 'English' : 'فارسی'}
        </span>
      )}
    </motion.button>
  );
};

export default LanguageToggle;
